import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { convertContryToOption } from "src/utils/convertToOption";
import { errorResponsesTrns } from "src/translate/responses";
import { ICountry } from "src/@types/country";

export const COUNTRIES_SLICE_NAME = "countries";

export const getCountriesAsync = createAsyncThunk(
  `${COUNTRIES_SLICE_NAME}/fetchCountries`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<ICountry[]>("/countries/");

      //CHANGE - temp use convertToOption
      return convertContryToOption(data);
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.countries;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
